exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".imgUpload[_v-fb51e1ba]{position:relative;border:1px dashed #08a;border-radius:3px;text-align:center}.imgUpload img[_v-fb51e1ba]{max-width:100%}.file-layout[_v-fb51e1ba]{position:absolute;top:0;left:0;right:0;bottom:0}.file-layout input[_v-fb51e1ba]{width:100%;height:100%;opacity:0}p[_v-fb51e1ba]{margin:0;font-size:12px;color:#a7a7a7;padding:8px 0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-fb51e1ba&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Imgupload.vue
 ** module id = 91
 ** module chunks = 0
 **/